import {
  FETCH_BOOKS_SUCCESS,
  FETCH_BOOKS_FAILURE,
  UPDATE_BOOK,
} from "./actionType";

const initialState = {
  allBooks: [],
  error: "",
  updateBook: null,
};

const booksReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BOOKS_SUCCESS:
      return {
        ...state,
        allBooks: action.payload,
        error: "",
      };

    case FETCH_BOOKS_FAILURE:
      return {
        ...state,
        allBooks: [],
        error: action.payload,
      };

    case UPDATE_BOOK:
      return {
        ...state,
        updateBook: action.payload,
      };

    default:
      return state;
  }
};

export default booksReducer;
